<template>
  <div class="contain">
    <div class="box" v-if="!isMobile">
      <header-view :isMobile="false" style="width: 100%"/>
      <div style="width: 100%; background: #fff; display: flex; justify-content: center; ">
        <div style="width: 60%; margin-top: 20px; padding: 50px 5%; border:1px solid #eee">
          <div class="middle">
            <div style="font-size: 25px;color: #000; margin-bottom: 15px">秒熊APP账号</div>
            <div style="display: flex; align-items: flex-end">
              <div class="flexColumn" style="margin-right: 30px">
                <span>秒熊APP登录手机号</span>
                <input v-model="phoneNum" maxlength="11" type="tel" placeholder="支持未注册手机号" style="padding-right: 60px" :disabled="progressState || isLogin || parseInt(codeTip) > 0" />
              </div>
              <div v-if="!isLogin" style="display: flex; align-items: flex-end">
                <div class="flexColumn" >
                  <span>验证码</span>
                  <input v-model="checkCode" placeholder="输入短信验证码" :disabled="progressState || !phoneNum" type="tel" maxlength="4" ref="code"/>
                </div>
                <button class="codeButton" @click="getCode" :class="{codeButtonAfter: parseInt(codeTip) > 0}" :disabled="parseInt(codeTip) > 0 || progressState">{{codeTip}}</button>
              </div>
              <button class="logout" v-else @click="logout" :disabled="progressState">退出当前帐号</button>
            </div>
          </div>
          <div class="middle" style="margin-top: 50px">
            <div style="font-size: 25px;color: #000; margin-bottom: 15px">上传长视频</div>
            <div class="info">上传后系统自动分离字幕，自动切割出适合学习的片段，处理成功后可在“上传”列表中查看专辑。</div>
            <div class="info">支持的链接：1.百度云、微云等网盘链接；2.优酷、爱奇艺、腾讯视频等视频网站链接</div>
            <div class="inputDiv">
              <div class="flexColumn" style="margin-top: 15px">
                <span>资源名称</span>
                <input v-model="movieName" :disabled="progressState" maxlength="100" />
              </div>
              <div class="flexColumn" style="margin-top: 15px">
                <div class="uploadType">
                  <span @click="isFile = false; clearFile()" :class="{underLine: !isFile, noClick: progressState}" style="margin-right: 10px">上传链接</span>
                  <span @click="isFile = true; fileUrl = ''" :class="{underLine: isFile, noClick: progressState}">上传文件</span>
                </div>
                <input v-if="!isFile" style="margin-top: 20px" placeholder="资源下载地址，支持所有网盘和视频网站链接" v-model="fileUrl" />
                <div v-else class="fileDiv">
                  <input type="file" id="fileUpload" class="fileUpload" @change="processFile($event)" :disabled="progressState" accept="video/mp4, .mp4 ,.mkv" />
                  <label for="fileUpload" style="display: flex; align-items: center">
                    <img src="@/assets/upload.png" style="margin-right: 5px"/>
                    <span v-if="fileName">已选择：{{fileName}}</span>
                    <span v-else>选择MP4、MKV格式的视频文件</span>
                  </label>
                  <span v-if="progressState" style="margin-left: 50px">上传进度: {{progressState}}</span>
                </div>
              </div>
              <button class="submitBut" :class="{submitButProgress: progressState}" @click="submitForm" :disabled="progressState">{{buttonText}}</button>
            </div>
          </div>
          <div class="footer">
            <div>
              <span style="font-size: 18px; color: #000">上传历史</span>
              <hr style="border: 0.5px solid #F2F2F2;" />
              <div class="tableTitle" style="font-size: 14px; color: #444">
                <span style="flex: 1.5">资源名称</span>
                <span>文件大小</span>
                <span>总时长</span>
                <span>处理状态</span>
                <span>切片状态</span>
              </div>
              <div v-if="videoHistory">
                <div v-for="(aData, index) in videoHistory" :key="index" class="tableTitle" style="font-size: 12px; color: #5F5F5F">
                  <span style="flex: 1.5; overflow: hidden; text-overflow: ellipsis;">{{aData.title}}</span>
                  <span>{{fileDisplaySize(aData.size)}}</span>
                  <span>未知</span>
                  <span>{{passState(aData.is_pass)}}</span>
                  <span>{{sliceState(aData.is_slice)}}</span>
                </div>
              </div>
              <div class="pagesStyle" style="margin-top: 30px" v-if="videoHistory">
                <button @click="curPage-=1" :disabled="curPage===0">上一页</button>
                <span v-if="historyInfo.pages <= 5" class="pagesStyle">
                  <button v-for="(aPage, index) in historyInfo.pages" :key="index" @click="curPage=index" :style="curPageStyle(index, false)">
                    {{aPage}}
                  </button>
                </span>
                <span v-else class="pagesStyle">
                  <button v-for="(aPage, index) in 5" :key="index" @click="curPage = index" :style="curPageStyle(index, false)">
                    {{aPage}}
                  </button>
                  <span style="margin-right: 5px">...</span>
                  <button @click="curPage = historyInfo.pages-1" :style="curPageStyle(curPage, true)">{{historyInfo.pages}}</button>
                </span>
                <button @click="curPage+=1" :disabled="curPage===historyInfo.pages-1">下一页</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <span>暂不支持手机上传</span>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import qs from 'qs'
import url from '@/util/url.js'
import OSS from 'ali-oss'
import MobileDetect from 'mobile-detect'
import { backResCheck } from '@/util/resCheck.js'
import HeaderView from '@/components/header'

export default {
  name: 'UploadVideo',
  components: {
    HeaderView
  },
  data () {
    return {
      isMobile: null,
      phoneNum: null,
      checkCode: null,
      userToken: null,
      isFile: false,
      fileData: null,
      movieName: null, // 用户上传的电影名称
      fileUrl: null,
      progressState: null,
      videoHistory: null,
      historyInfo: {
        count: null,
        pages: null,
        pageCount: 20
      },
      curPage: 0,
      buttonText: '提交',
      codeTip: '获取验证码',
      timer: null,
      isLogin: false
    }
  },
  computed: {
    // 选择的视频文件名称
    fileName () {
      if (this.fileData) {
        return this.fileData.name
      } else {
        return null
      }
    }
  },
  methods: {
    curPageStyle (index, last) {
      if (last) {
        return index === this.historyInfo.pages - 1 ? {
          background: '#E826A7',
          color: '#fff'
        } : null
      }
      return index === this.curPage ? {
        background: '#E826A7',
        color: '#fff'
      } : null
    },
    passState (isPass) {
      switch (isPass) {
        case 0:
          return '未处理'
        case 1:
          return '审核通过'
        case 2:
          return '审核不通过'
        default:
          return '未知'
      }
    },
    sliceState (isSlice) {
      switch (isSlice) {
        case 0:
          return '未开始'
        case 1:
          return '切片中'
        case 2:
          return '切片成功'
        case 3:
        case 4:
        case 5:
          return '切片失败'
        default:
          return '未知'
      }
    },
    goRoute (route) {
      this.$router.push(route)
    },
    processFile (event) {
      this.fileData = event.target.files[0]
    },
    fileDisplaySize (size) {
      if (size === '') {
        return '未知'
      } else if ((size / Math.pow(1024, 3)) > 1) {
        return `${(size / Math.pow(1024, 3)).toFixed(2)}G`
      } else if ((size / Math.pow(1024, 2)) > 1) {
        return `${(size / Math.pow(1024, 2)).toFixed(2)}M`
      } else {
        return `${(size / 1024).toFixed(2)}kb`
      }
    },
    clearFile () {
      this.fileData = null
    },
    async uploadProgress (progress) {
      this.progressState = `${(progress * 100).toFixed(2)}%`
    },
    // 用户登录
    async login () {
      if (this.phoneNum && this.checkCode) {
        try {
          let response = await axios.post(url.login, qs.stringify({
            mobile: this.phoneNum,
            checkCode: this.checkCode
          }))
          if (backResCheck(response.data)) {
            this.userToken = response.data.data.token
            localStorage.setItem('uploadVideo', JSON.stringify({
              mobile: this.phoneNum,
              token: this.userToken
            }))
            this.isLogin = true
            this.getVideoHisoty()
          } else {
            this.$message.error(response.data.msg)
          }
        } catch (e) {
          this.$message.error('用户登录，未知错误')
        }
      } else {
        this.$message('请输入手机号或验证码')
      }
    },
    logout () {
      localStorage.removeItem('uploadVideo')
      this.isLogin = false
      this.userToken = null
      this.videoHistory = null
      this.resetForm()
    },
    // 获取历史视频
    getVideoHisoty () {
      axios.get(`${url.videoHistory}?page=${this.curPage}&count=${this.historyInfo.pageCount}`,
        {
          headers: {
            userToken: this.userToken
          }
        })
        .then((res) => {
          if (backResCheck(res.data)) {
            this.videoHistory = res.data.data
            if (!this.curPage && res.data.data.length >= 1) {
              this.historyInfo.count = res.data.data[0].long_video_count
              this.historyInfo.pages = Math.ceil(this.historyInfo.count / this.historyInfo.pageCount)
            }
            this.isLogin = true
          } else {
            this.$message.error(res.data.msg)
          }
        })
    },
    getCode () {
      if (this.phoneNum) {
        let time = 60
        // 发送手机验证码
        let response = axios.post(url.getCheckCode, qs.stringify({
          mobile: this.phoneNum,
          type: 2
        }))
        response.then((result) => {
          if (backResCheck(result.data)) {
            this.$refs.code.focus()
            this.$message.success('验证码发送成功')
            // 计时器
            this.timer = setInterval(() => {
              this.codeTip = `${time--}秒`
            }, 1000)
          } else {
            this.$message.error(result.data.msg)
            clearInterval(this.timer)
          }
        }, () => {
          this.$message.error('未知错误')
        })
      } else {
        this.$message.info('请先输入手机号码')
      }
    },
    // 表单提交 && 用户登录获取token
    async submitForm () {
      // 防止连续点击
      this.progressState = '0%'
      if (!this.isLogin) {
        this.$message('用户未登录，请输入手机号和验证码')
      } else {
        try {
          await this.videoUpload()
        } catch (e) {
          this.$message.error('视频提交，未知错误')
        }
      }
      this.buttonText = '提交'
      this.progressState = null
    },
    // 视频链接上传或文件上传
    async videoUpload () {
      if (this.movieName) {
        if (this.fileUrl || this.fileName) {
          // 视频链接上传
          if (this.fileUrl) {
            this.progressState = true
            let response = await axios.post(url.uploadVideo, qs.stringify({
              title: this.movieName,
              url: this.fileUrl
            }),
            {
              headers: {
                userToken: this.userToken
              }
            })
            if (backResCheck(response.data)) {
              this.curPage = 0
              this.getVideoHisoty()
              this.progressState = null
              this.$message.info('上传成功')
              this.resetForm()
            } else {
              this.$message.error(response.data.msg)
            }
          }
          // 视频文件上传
          if (this.fileName) {
            await this.uploadOss()
          }
        } else {
          this.$message.info('请输入资源链接或者选择需上传的视频文件')
        }
      } else {
        this.$message.info('请输入资源名称再提交')
      }
    },
    async uploadOss () {
      // 获取 sst 临时凭证
      let response = await axios.post(url.getSts, qs.stringify({
        usage: 'userLongVideo'
      }),
      {
        headers: {
          userToken: this.userToken
        }
      })
      // oss sdk 上传准备
      if (backResCheck(response.data)) {
        let clientObj = response.data.data
        let ossClient = new OSS({
          region: clientObj.region,
          accessKeyId: clientObj.access_key_id,
          accessKeySecret: clientObj.access_key_secret,
          stsToken: clientObj.security_token,
          bucket: clientObj.bucket_name
        })
        this.buttonText = '文件正在上传'
        // oss 文件上传
        try {
          response = await ossClient.multipartUpload(clientObj.object_key, this.fileData,
            {
              progress: this.uploadProgress,
              partSize: 100 * 1024
            })
          // 提交oss上传状态
          if (response.res.statusCode === 200) {
            response = await axios.post(url.uploadVideo, qs.stringify({
              title: this.movieName,
              objectKey: clientObj.object_key,
              size: this.fileData.size
            }),
            {
              headers: {
                userToken: this.userToken
              }
            })
            if (backResCheck(response.data)) {
              this.curPage = 0
              this.getVideoHisoty()
              this.$message.success('上传成功')
              this.resetForm()
            } else {
              this.$message.error(response.data.msg)
            }
          } else {
            this.$message.error('上传失败请重新上传')
          }
        } catch (e) {
          this.$message.error('上传失败请重新上传')
        }
      } else {
        this.$message.error(response.data.msg)
      }
    },
    resetForm () {
      this.movieName = null
      this.fileUrl = null
      if (this.fileName) {
        this.clearFile()
      }
    }
  },
  watch: {
    codeTip () {
      if (parseInt(this.codeTip) <= 0) {
        clearInterval(this.timer)
        this.codeTip = '重新获取'
      }
    },
    checkCode () {
      if (this.checkCode.length === 4) {
        this.login()
      }
    },
    phoneNum () {
      if (this.checkCode && this.checkCode.length === 4 && this.phoneNum.length === 11) {
        this.login()
      }
    },
    curPage () {
      this.getVideoHisoty()
    }
  },
  mounted () {
    this.isMobile = (new MobileDetect(window.navigator.userAgent)).mobile()
    let storage = localStorage.getItem('uploadVideo')
    if (storage) {
      this.phoneNum = JSON.parse(storage).mobile
      this.userToken = JSON.parse(storage).token
      this.getVideoHisoty()
    }
  }
}
</script>
<style scoped>
.box {
  font-size: 20px;
  background-image: url('../assets/headerBG.png');
  background-repeat:no-repeat;
  background-size:100% 100%;-moz-background-size:100% 100%;
}
.middle {
  width: 70%;
}
.middle .info {
  font-size: 12px;
  color: #717171;
}
.middle .inputDiv {
  margin-top: 15px;
  font-size: 15px;
}
.middle .flexColumn {
  display: flex;
  flex-direction: column;
  /* margin-right: 15px; */
  font-size: 12px;
  color: #505050;
}
.codeButton {
  background: #E826A7;
  height: 31px;
  width: 80px;
  margin-left: 10px;
  padding: 3px 10px;
  border: none;
  border-radius: 5px;
  outline: inherit;
  color: white;
}
.codeButtonAfter {
  background: #D9D9D9;
  /* pointer-events: none; */
}
.flexColumn > span {
  margin-bottom: 10px;
}
.middle .lastLine {
  margin-top: 10px;
}
.submitBut {
  margin-top: 30px;
  font-size: 15px;
  width: 30%;
  color: white;
  height: 30px;
  border: none;
  background: #E826A7;
  border-radius: 8px;
  outline: inherit;
}
.submitButProgress {
  background: #eee;
}
input {
  background: #F1F2F6;
  border-radius: 5px;
  padding: 3px 10px;
  border: none;
  height: 25px;
}
input:focus,textarea:focus {
  outline: none;
  border: 1px solid #f60;
}
.footer {
  margin-top: 50px;
  width: 100%;
}
.tableTitle {
  display: flex;
  align-items: center;
}
.tableTitle span {
  flex: 1;
  padding: 5px;
}
.fileDiv {
  margin-top: 20px;
  display: flex;
  align-items: center;
}
.fileUpload {
  width: 0;
  height: 0;
  opacity: 0;
  overflow: hidden;
  position: absolute;
  z-index: -1;
}
.fileUpload + label {
  cursor: pointer;
  font-size: 12px;
  color: #404142;
  padding: 8px 20px;
  border:1px solid #eee;
  border-radius: 8px;
}
.uploadType span {
  cursor: pointer;
}
.underLine {
  border-bottom: 2px solid #E826A7;
}
.noClick {
  pointer-events: none;
}
.logout {
  background: #ebebeb;
  border-radius: 5px;
  padding: 3px 10px;
  border: none;
  height: 31px;
  outline: inherit;
}
.pagesStyle {
  display: flex;
  justify-content: center;
}
.pagesStyle button {
  margin-right: 5px;
  border: none;
  font-size: 12px;
  border: 1px solid #D0D0D0;
  background: #fff;
  color: #666;
  border-radius: 3px;
  outline: inherit;
  height: 25px;
}
.pagesStyle button:disabled, button[disabled]{
  opacity: 0.5;
}
</style>
